<template>
  <div class="qualifications">
    <img src="../../assets/img/许可证@2x.png" alt="" />
  </div>
</template>

<script>
export default {
  name: 'qualifications'
}
</script>

<style lang="scss" scoped>
.qualifications {
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  padding-top: 1.333rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: center;
  img {
    width: 8rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/Qualifications.vue